import React from 'react';
import { Box, Typography } from '@mui/material';
import {
  remCalc,
  translate,
} from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import Config from '@monorepo/shared/src/config/common';

const t = (key: string, options?) => translate('helpAndSupport', key, options);

const HelpAndSupportFooter: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      {Config.contactInformation.map(({ title, value }, key) => (
        <Typography
          key={`contact-info-${key}`}
          gutterBottom={true}
          style={{ fontSize: remCalc(14) }}
        >
          {t(title)} <strong>{value}</strong>
        </Typography>
      ))}
    </Box>
  );
};

export default HelpAndSupportFooter;
